import { Component, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { ToastComponent } from '../../shared/toast/toast.component';
import { RuleService } from '../../services/rule.service';
import { setClassInvalid } from '../../shared/functions';
import { ee } from '../../shared/constants';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-add-rule-form',
  templateUrl: './add-rule-form.component.html',
  standalone: false
})
export class AddRuleFormComponent {
  private ruleService = inject(RuleService);
  private formBuilder = inject(UntypedFormBuilder);
  toast = inject(ToastComponent);


  addRuleForm = this.createRuleForm();
  setClassInvalid = setClassInvalid;

  createRuleForm(): UntypedFormGroup {
    return this.formBuilder.group({
      name: ['', [Validators.required]],
      value: ['', [Validators.required, Validators.maxLength(512)]]
    });
  }

  validateRule(): void {
    this.ruleService.validate(this.addRuleForm.value)
      .subscribe({
        next: res => this.toast.setMessage('Rule is valid!', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }

  addRule(): void {
    this.ruleService.add(this.addRuleForm.value)
      .pipe(finalize(() => ee.emit('getRules')))
      .subscribe({
        next: res => this.toast.setMessage('Rule added successfully.', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }

}
